import React from 'react';
import numeral from 'numeral';

export default class GraphMoney extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let money = "$"+numeral(this.props.item.danos).format('0,0');
    return (
      <div className="money-container">
        <figure>
          <img src="http://widgets.biobiochile.cl/terremoto1939/dinerales.png" />
        </figure>
        <h1>{money}</h1>
          <h3>{this.props.item.moneda} Millones de la época fueron contemplados en pérdidas por los daños</h3>
      </div>
    )
  }
};



/** WEBPACK FOOTER **
 ** ./client/GraphMoney.js
 **/